// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"4df4e063","2587":"abbcdd31","2814":"abbcdd31","2815":"0932ff45","3550":"5590196c","5140":"4df4e063","7739":"abbcdd31","9704":"4df4e063","9727":"4df4e063","9969":"4df4e063"}[chunkId] + ".chunk.css";
};